const hasPlaceholder = (element) => !!(element.getAttribute("placeholder") && element.value === "");

export default class {
  constructor() {
    this.$forms = $(".wpcf7");
  }

  init() {
    this.handleFloatingLabels();

    $(() => {
      this.$forms.on("submit", (event) => {
        const button = $(event.target).find("[type=submit]");
        button.attr("disabled", true);
        button.addClass("loader");
      });

      this.$forms.on("wpcf7submit", (event) => {
        const button = $(event.target).find("[type=submit]");
        button.attr("disabled", false);
        button.removeClass("loader");
      });
    });
  }

  handleFloatingLabels() {
    $(".form-group:not(.clean)").each((_, el) => {
      const $input = $(el).find("select, textarea, input");

      if ($input[0]) {
        $(el).toggleClass("filled", !!$input.val() || hasPlaceholder($input[0]));
      }
    });

    $(document).on("change", ".form-group:not(.clean) select", (event) => {
      const { value } = event.target.options[event.target.options.selectedIndex];
      $(event.target).parents(".form-group").toggleClass("filled", !!value.length);
    });

    $(document).on("focus", ".form-group:not(.clean) input, .form-group:not(.clean) textarea", (event) => {
      $(event.target).parents(".form-group").addClass("filled");
    });

    $(document).on("blur", ".form-group:not(.clean) input, .form-group:not(.clean) textarea", (event) => {
      $(event.target)
        .parents(".form-group")
        .toggleClass("filled", !!$(event.target).val() || hasPlaceholder(event.target));
    });
  }
}
